import { Component } from '@angular/core';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';
import {
  DAIRYNEXT_WORKSPACE_ID,
  DAIRYNEXT_REPORT_IDS,
  SINGLE_PAGE_POWERBI_CONFIG,
} from 'src/app/shared/models/powerbi-config.model';

@Component({
  selector: 'app-co2-deliveries',
  templateUrl: './co2-deliveries.component.html',
  imports: [PowerbiReportComponent],
})
export class Co2DeliveriesComponent {
  public readonly workspaceId = DAIRYNEXT_WORKSPACE_ID;
  public readonly reportId = DAIRYNEXT_REPORT_IDS.CO2_YOUR_DELIVERIES;
  public readonly baseEmbedConfig = SINGLE_PAGE_POWERBI_CONFIG;
}
